var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"loading":_vm.loading},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.title,"value":item.id}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }